import React, { memo } from 'react';
import PageBoxes from '../../PageBoxes/Components';
import { TextLoading } from '../../../Components/Loaders';

const ProductPageBoxTopLoading = () => {
  return (
    <div className="ebslider">
      <div className="ebslider__content product-card--loading">
        <TextLoading height={200} />
      </div>
    </div>
  );
};

export const ProductPageBoxTop = memo(() => {
  return (
    <div
      className="item item--bxx"
      style={{ marginTop: '1rem', marginBottom: '1rem' }}
    >
      <PageBoxes
        loaderComponent={<ProductPageBoxTopLoading />}
        itemClassName=""
        position="top"
      />
    </div>
  );
});

export default ProductPageBoxTop;
